import axios from 'axios';

export default {
  all(params = {}) {
    return axios.get('/jobs/all', {params});
  },
  category(params = {}) {
    return axios.get('/jobs/category', {params});
  },
  detail(id: number) {
    return axios.get(`/jobs/detail/${id}`);
  },
  applyJobs(payload = {}) {
    return axios.post(`/jobs/applies`, payload);
  },
  getQuiz(params = {}) {
    return axios.get(`/exam/question`, {params});
  },
  sendQuiz(payload = {}) {
    return axios.post(`/exam/validator-answare`, payload);
  },
  changeStatusApplies(id: number, payload = {}) {
    return axios.post(`/jobs/status-apply/change/${id}`, payload);
  },
  newQuiz(payload = {}) {
    return axios.post(`/exam/new`, payload);
  },
  updateQuiz(payload = {}) {
    return axios.post(`/exam/save`, payload);
  },
  checkProgress(params = {}) {
    return axios.get(`/jobs/check`, {params});
  },
  getQuizIntroduction(params = {}) {
    return axios.get(`/exam/question-setting`, {params});
  },
  getQuizIntroductionUser(params = {}) {
    return axios.get(`/exam/question-user`, {params});
  },
  allStatusApply(params = {}) {
    return axios.get('/jobs/status-apply', {params});
  },
  detailStatusApply(id: number) {
    return axios.get(`/jobs/status-apply/${id}`);
  },
};
